const SET_MENU_OPEN = 'SET_MENU_OPEN';
const SET_FORM_TOPIC = 'SET_FORM_TOPIC';
const SET_FORM_TOPIC_ERROR = 'SET_FORM_TOPIC_ERROR';
const SET_FORM_POLICY = 'SET_FORM_POLICY';
const SET_FORM_POLICY_ERROR = 'SET_FORM_POLICY_ERROR';
const SET_FORM_NAME = 'SET_FORM_NAME';
const SET_FORM_NAME_ERROR = 'SET_FORM_NAME_ERROR';
const SET_FORM_AGENCY_NAME = 'SET_FORM_AGENCY_NAME';
const SET_FORM_AGENCY_NAME_ERROR = 'SET_FORM_AGENCY_NAME_ERROR';
const SET_FORM_EMAIL = 'SET_FORM_EMAIL';
const SET_FORM_EMAIL_ERROR = 'SET_FORM_EMAIL_ERROR';
const SET_FORM_PHONE = 'SET_FORM_PHONE';
const SET_FORM_PHONE_ERROR = 'SET_FORM_PHONE_ERROR';
const SET_FORM_MESSAGE = 'SET_FORM_MESSAGE';
const SET_FORM_MESSAGE_ERROR = 'SET_FORM_MESSAGE_ERROR';
const SET_FORM_CITY = 'SET_FORM_CITY';
const SET_FORM_CITY_ERROR = 'SET_FORM_CITY_ERROR';
const SET_FORM_STREET = 'SET_FORM_STREET';
const SET_FORM_STREET_ERROR = 'SET_FORM_STREET_ERROR';
const SET_FORM_ZIP = 'SET_FORM_ZIP';
const SET_FORM_ZIP_ERROR = 'SET_FORM_ZIP_ERROR';
const SET_MODAL_SUCCESS_OPEN = 'SET_MODAL_SUCCESS_OPEN';
const SET_LOADING = 'SET_LOADING';
const SET_CONTACT_US_LOADING = 'SET_CONTACT_US_LOADING'
const SET_CONTACT_AGENT_LOADING = 'SET_CONTACT_AGENT_LOADING'
const SET_BECOME_AGENT_LOADING = 'SET_BECOME_AGENT_LOADING'
const SET_APPLY_LOADING = 'SET_APPLY_LOADING'
const SET_PAGE_NAME = 'SET_PAGE_NAME'


const combineConst = {
    SET_MENU_OPEN,
    SET_FORM_TOPIC,
    SET_FORM_TOPIC_ERROR,
    SET_FORM_POLICY,
    SET_FORM_POLICY_ERROR,
    SET_FORM_NAME,
    SET_FORM_NAME_ERROR,
    SET_FORM_AGENCY_NAME,
    SET_FORM_AGENCY_NAME_ERROR,
    SET_FORM_EMAIL,
    SET_FORM_EMAIL_ERROR,
    SET_FORM_PHONE,
    SET_FORM_PHONE_ERROR,
    SET_FORM_MESSAGE,
    SET_FORM_MESSAGE_ERROR,
    SET_FORM_CITY,
    SET_FORM_CITY_ERROR,
    SET_FORM_STREET,
    SET_FORM_STREET_ERROR,
    SET_FORM_ZIP,
    SET_FORM_ZIP_ERROR,
    SET_MODAL_SUCCESS_OPEN,
    SET_LOADING,
    SET_CONTACT_US_LOADING,
    SET_CONTACT_AGENT_LOADING,
    SET_BECOME_AGENT_LOADING,
    SET_APPLY_LOADING,
};

export default combineConst;
